import './welcome.css'

const EmptyWelcomeGridItem = () => {
    return (
        <div className='EmptyWelcomeGridItem'></div>
    );
}

export default EmptyWelcomeGridItem